export const overlayAnimation = {
  open: {
    opacity: 1,
    display: 'block',
    transition: {
      duration: 0.1
    }
  },
  closed: {
    opacity: 0,
    transitionEnd: {
      display: 'none'
    },
    transition: {
      duration: 0.2
    }
  }
};
export const mainContainerAnimation = {
  open: {
    opacity: 1,
    height: '543px',
    display: 'block',
    transition: {
      duration: 0.2
    }
  },
  closed: {
    opacity: 0,
    height: '0%',
    transitionEnd: {
      display: 'none'
    },
    transition: {
      duration: 0.2
    }
  }
};
export const wrapperContainerAnimation = {
  open: {
    opacity: 1,
    height: '100%',
    display: 'block',
    transition: {
      duration: 0.2
    }
  },
  closed: {
    opacity: 0,
    height: '0%',
    transitionEnd: {
      display: 'none'
    },
    transition: {
      duration: 0.2
    }
  }
};
export const listContainerAnimation = {
  open: {
    height: '100%',
    opacity: 1,
    transition: {
      duration: 0.2,
      staggerChildren: 0.05
    }
  },
  closed: {
    height: '0%',
    transitionEnd: {
      opacity: 0
    },
    transition: {
      duration: 0.2
    }
  }
};
export const itemListAnimation = {
  open: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2
    }
  },
  closed: {
    transitionEnd: {
      opacity: 0
    },
    y: -10,
    transition: {
      duration: 0.2
    }
  }
};